module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawHorizontalWhite.31fc3d0f.svg";